var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sliderrtl'),_c('Aboutrtl'),_c('Featurertl'),_c('Workrtl'),_c('Screenshotsrtl'),_c('Teamrtl'),_c('Packagertl'),_c('Testimonialrtl'),_c('FAQrtl'),_c('Blogrtl'),_c('DownloadRTL'),_c('Footerrtl'),_c('Subscribertl'),_c('Copyrightrtl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }